<div
  id="main-container"
  [ngClass]="{
    'flanges-open': hideContaninerGet === false || hideContaninerAPIPackage === false,
    'flanges-close': hideContaninerGet === true && hideContaninerAPIPackage === true,
  }"
  class="main-container"
>
  <div class="container">
    <h1 class="main-title">{{ 'apiDocs.mainTitle' | translate }}</h1>
    <span>{{ 'apiDocs.subtitle' | translate }}</span>
  </div>
  <div class="container mt-4">
    <h3>{{ 'apiDocs.packages.title' | translate }}</h3>
    <div
      id="flange-get"
      class="container flange-get pt-2 pb-2 cursor"
      [ngClass]="{
        'flange-get-open': hideContaninerGet === false,
        'flange-get-close': hideContaninerGet === true,
      }"
      (click)="toggleGet()"
      (keydown.enter)="toggleGet()"
      tabindex="0"
    >
      <div class="label-get me-3">
        {{ 'apiDocs.packages.method' | translate }}
      </div>
      <b class="me-4 url">{{ 'apiDocs.packages.endpoint' | translate }}</b>
      <span class="url-title">{{ 'apiDocs.packages.endpointTitle' | translate }}</span>
      <fa-icon [icon]="faAngle1" style="margin-left: 700px; font-size: 20px"></fa-icon>
    </div>
    <div id="container-get" class="container container-get mb-2" [hidden]="hideContaninerGet">
      <p>{{ 'apiDocs.packages.description' | translate }}</p>
      <div
        id="flange-description"
        class="container flange-description cursor"
        [ngClass]="{
          'flange-description-open': hideContaninerDescription === false,
          'flange-description-close': hideContaninerDescription === true,
        }"
        (click)="toggleDescription()"
        (keydown.enter)="toggleDescription()"
        tabindex="0"
      >
        <span>
          <b>{{ 'apiDocs.packages.fieldsTitle' | translate }}</b>
          <fa-icon
            [icon]="faAngle2"
            style="margin-left: 780px; font-size: 20px; color: white"
          ></fa-icon>
        </span>
      </div>
      <div
        id="container-description"
        class="container container-description"
        [hidden]="hideContaninerDescription"
      >
        <table class="table table-dark">
          <thead>
            <tr>
              <th scope="col" style="border-top: none">{{ 'apiDocs.tables.field' | translate }}</th>
              <th scope="col" style="border-top: none">
                {{ 'apiDocs.tables.description' | translate }}
              </th>
              <th scope="col" style="border-top: none">
                {{ 'apiDocs.tables.sampleValue' | translate }}
              </th>
            </tr>
          </thead>
          <tbody [innerHTML]="'apiDocs.packages.fieldsRows' | translate"></tbody>
        </table>
      </div>
      <br />
      <div class="row flange-response">
        <span
          ><b>{{ 'apiDocs.responses.title' | translate }}</b></span
        >
      </div>

      <div class="container">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">{{ 'apiDocs.tables.code' | translate }}</th>
              <th scope="col">{{ 'apiDocs.tables.description' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>200</td>
              <td>
                <span class="mb-2">{{ 'apiDocs.responses.ok' | translate }}</span>
                <div>
                  <span
                    class="example-option cursor"
                    [ngClass]="{ 'selected-option': selectedOption === false }"
                    (click)="toggleOption()"
                    (keydown.enter)="toggleOption()"
                    role="button"
                    tabindex="0"
                    >{{ 'apiDocs.responses.exampleValue' | translate }}</span
                  >
                  <span
                    class="schema-option cursor"
                    [ngClass]="{ 'selected-option': selectedOption === true }"
                    (click)="toggleOption()"
                    (keydown.enter)="toggleOption()"
                    role="button"
                    tabindex="0"
                    >{{ 'apiDocs.responses.schema' | translate }}</span
                  >
                  <div class="container mt-2" [hidden]="selectedOption">
                    <pre class="container-example">{{ JsonExample | json }}</pre>
                  </div>
                  <div class="container mt-2" id="schema" [hidden]="!selectedOption">
                    <div class="container container-schema">
                      <span class="flange-schema"
                        >{{ 'apiDocs.schemas.apiPackage' | translate }}
                        <span class="signo">&#123;</span></span
                      >
                      <div [innerHTML]="'apiDocs.schemas.rows' | translate"></div>
                      <span class="signo">&#125;</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>400</td>
              <td>
                <span>{{ 'apiDocs.responses.badRequest' | translate }}</span>
              </td>
            </tr>
            <tr>
              <td>401</td>
              <td>
                <span>{{ 'apiDocs.responses.unauthorized' | translate }}</span>
              </td>
            </tr>
            <tr>
              <td>404</td>
              <td>
                <span>{{ 'apiDocs.responses.notFound' | translate }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <div
      class="container flange-schemas cursor pt-2 pb-2"
      [ngClass]="{
        'flange-schemas-open': hideContaninerSchemas === false,
        'flange-schemas-close': hideContaninerSchemas === true,
      }"
      (click)="toggleSchemas()"
      (keydown.enter)="toggleSchemas()"
      role="button"
      tabindex="0"
    >
      <span>
        <b style="font-size: 22px">{{ 'apiDocs.schemas.title' | translate }}</b>
        <fa-icon
          [icon]="faAngle3"
          id="Angle3"
          style="margin-left: 940px; font-size: 20px"
        ></fa-icon>
      </span>
    </div>
    <div
      id="container-schemas"
      class="container container-schemas mb-2"
      [hidden]="hideContaninerSchemas"
    >
      <div class="container container-schema">
        <span
          class="flange-schema cursor"
          (click)="toggleApiPackage()"
          (keydown.enter)="toggleApiPackage()"
          role="button"
          tabindex="0"
          >{{ 'apiDocs.schemas.apiPackage' | translate }}
          <fa-icon
            [icon]="faAngle4"
            id="Angle4"
            style="margin-left: 10px; font-size: 15px"
          ></fa-icon
        ></span>
        <div id="ApiPackage" [hidden]="hideContaninerAPIPackage">
          <span class="signo">&#123;</span>
          <div [innerHTML]="'apiDocs.schemas.rows' | translate"></div>
          <span class="signo">&#125;</span>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
</div>
